import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SnackbarService } from '../error/snackbar.service';
import { ContractorListDto } from '../../models/contractors/contractor-list-dto';
import { ContractorDetailsDto } from '../../models/contractors/contractor-details-dto';
import { ContractorLookupDto } from '../../models/contractors/contractor-lookup-dto';
import { browserOnly } from './browser-only.util';

@Injectable({
  providedIn: 'root'
})
export class ContractorApiService {
  private apiUrl = environment.apiBaseUrl;
  errorResponse: string = "";

  constructor(
    private http: HttpClient,
    private snackBarService: SnackbarService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  getContractorList(): Observable<ContractorListDto[]> {
    return browserOnly<ContractorListDto[]>(this.platformId, [], () => this.http.get<ContractorListDto[]>(`${this.apiUrl}/contractors`).pipe(catchError(error => this.snackBarService.handleApiError(error))));
  }

  getContractor(id: number): Observable<ContractorDetailsDto> {
    return browserOnly<ContractorDetailsDto>(this.platformId, {} as ContractorDetailsDto, () => this.http.get<ContractorDetailsDto>(`${this.apiUrl}/contractor/${id}`).pipe(catchError(error => this.snackBarService.handleApiError(error))));
  }

  getContractorLookups(): Observable<ContractorLookupDto[]> {
    return browserOnly<ContractorLookupDto[]>(this.platformId, [], () => this.http.get<ContractorLookupDto[]>(`${this.apiUrl}/contractors/lookup`).pipe(catchError(error => this.snackBarService.handleApiError(error))));
  }
}
